import { ROUTES_NOTIFICATION_SETTINGS, ROUTES_NOTIFICATIONS } from '@/constants/routes';

export default {
    path: '/notifications',
    name: 'notifications-page',
    component: () => import(/*webpackChunkName: 'notifications'*/ '@/views/notifications/NotificationsMain.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/notifications/settings',
            name: ROUTES_NOTIFICATION_SETTINGS,
            component: () =>
                import(/*webpackChunkName: 'notifications'*/ '@/views/notifications/NotificationSettings.vue')
        },
        {
            path: '/notifications/all',
            name: ROUTES_NOTIFICATIONS,
            component: () => import(/*webpackChunkName: 'notifications'*/ '@/views/notifications/Notifications.vue')
        }
    ]
};
